<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="医生姓名">
              <a-input placeholder="请输入医生姓名" v-model="queryParam.doctorName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('withdraw_record')">导出</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <span slot="buts" slot-scope="text, record" style="display: flex; margin-left: 3px;">
            <a-dropdown>
             <span v-if="record.status == 0">
                 <a-button @click="getBut(record)" style="background-color: #05e809;color:#09090c;">通过</a-button>
             </span>
               <span v-else></span>
           </a-dropdown>
           <a-dropdown  style="margin-left:9px; ">
                <div id="components-modal-demo-position">
                  <span v-if="record.status == 0">
                        <a-button  @click="handlWithWeb(record,$event)"  style="background-color: #d6dadc;">拒绝</a-button>
                  </span>
                  <span v-else></span>
                 <a-modal
                   title="拒绝"
                   style="top: 20px;"
                   :visible="modalVisible"
                   :confirm_loading="confirmLoading"
                   @ok="handSumit"
                   @cancel="handCancel"
                   cancelText="关闭"
                 >
               <a-form-item>
                 <a-textarea v-model="form.reason" placeholder="请输入拒绝原因" style="margin-top: 30px; width: 100%;height: 600px;align: center"></a-textarea>
               </a-form-item>
               </a-modal>
              </div>
            </a-dropdown>
        </span>
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <withdraw-record-modal ref="modalForm" @ok="modalFormOk"></withdraw-record-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import WithdrawRecordModal from './WithdrawRecordModal'
  import JFormContainer from '@comp/jeecg/JFormContainer'
  import JDate from '@comp/jeecg/JDate'

  import { postAction, putAction } from '@api/manage'

  export default {
    name: 'WithdrawRecordList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      WithdrawRecordModal,
      JFormContainer,
      JDate,

    },
    data () {
      return {
        description: 'withdraw_record管理页面',
        modalVisible: false,
        confirmLoading: false,
        // 表头
        columns: [
          {
            title:'医生ID',
            align:"center",
            dataIndex: 'doctorId'
          },
          {
            title:'医生姓名、手机号',
            align:"center",
            dataIndex: 'doctorInfo'
          },
          {
            title:'提现金额',
            align:"center",
            dataIndex: 'amount'
          },
          {
            title:'状态',
            align:"center",
            dataIndex: 'status',
            customRender:function (res) {
              var status = "";
              if(res == 0){
                status = "提现中";
              }else if(res == 1){
                status = "已审批";
              }else if(res == 2){
                status = "已拒绝";
              }
              return status;
            }
          },
          {
            title:'税率',
            align:"center",
            dataIndex: 'taxRatio'
          },
          {
            title:'税费',
            align:"center",
            dataIndex: 'taxFee'
          },
          {
            title:'开户信息',
            align:"center",
            dataIndex: 'accountInfo'
          },
          {
            title:'实现到账金额',
            align:"center",
            dataIndex: 'receipt'
          },

          {
            title:'创建时间',
            align:"center",
            dataIndex: 'createTime',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'创建人',
            align:"center",
            dataIndex: 'createBy'
          },
          {
            title:'提现按钮',
            align:"center",
            modalVisible: false,
            loading:false,
            width:210,
            scopedSlots: { customRender: 'buts' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],

        form: {
          modalVisible: false,
          id:'',
          reason:'',
          content:''
        },
        url: {
          list: "/carry/withdrawRecord/list",
          info: "/carry/withdrawRecord/drawalOperate",
          delete: "/carry/withdrawRecord/delete",
          deleteBatch: "/carry/withdrawRecord/deleteBatch",
          exportXlsUrl: "/carry/withdrawRecord/exportXls",
          importExcelUrl: "carry/withdrawRecord/importExcel",
        },

        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
      getBut(e){
        let param = { };
        param.status = 1
        param.id = e.id

        postAction(this.url.info,param).then(res=>{
          if(res.success){
            this.$message.success(res.result.message)
            this.dictOptions()
          }else{
            this.$message.warning(res.result.message)

          }
        })
      },
      handlWithWeb(modalVisible,event) {
        this.modalVisible = modalVisible;
        this.form.id = modalVisible.id;
        event.currentTarget.innerHTML="已发送";

      },
      handSumit(){
        let param = { };
        param.status = 2;
        param.id = this.form.id;
        param.reason = this.form.reason;

        postAction(this.url.info,param).then(res=>{

          if(res.success){
            this.$message.success(res.result.message.code)
          }else{
            this.$message.warning(res.result.message)
          }
        }).catch((error)=>{
          console.log(error);
        })
      },
      handCancel(){
        this.modalVisible = false;
      }

    }
  }

</script>
<style scoped>
  @import '~@assets/less/common.less';

</style>